const API_BASE_URL = "/api/";

export type DocumentClassification = "Unclassified" | "Classified" | "TopSecret";

export interface Document {
  name: string;
  classification: DocumentClassification;
}

interface RustResult<T> {
  Ok?: T;
  Err?: string;
}

async function apiQuery<T>(url: string, body?: BodyInit): Promise<T> {
  const method = body === undefined ? "GET" : "POST";
  const response = await fetch(url, { method, body });
  if (response.status !== 200) {
    throw new Error(`API Error ${response.status}: ${response.statusText}\n${await response.text()}`);
  }
  const data = await response.json() as RustResult<T>;
  if (data.Ok !== undefined) {
    return data.Ok;
  } else {
    throw new Error(data.Err);
  }
}

export async function uploadDocument(file: File): Promise<void> {
  const formData = new FormData();
  formData.append("file", file);
  await apiQuery(`${API_BASE_URL}documents`, formData);
}

export async function getDocuments(): Promise<Document[]> {
  const documents = await apiQuery<Document[]>(
    `${API_BASE_URL}documents`,
  );
  return documents;
}

export function getDocumentUrl(name: string): string {
  return `${API_BASE_URL}documents/${encodeURIComponent(name)}`;
}

export async function uploadPostprocessor(file: File): Promise<void> {
  throw new Error("Postprocessor upload is disabled.");

  const formData = new FormData();
  formData.append("file", file);
  await apiQuery(`${API_BASE_URL}plugins`, formData);
}

export async function getPostprocessors(): Promise<string[]> {
  return await apiQuery(`${API_BASE_URL}plugins`);
}

export function getPostprocessorUrl(name: string): string {
  return `${API_BASE_URL}plugins/${encodeURIComponent(name)}`;
}

export async function compileDocument(documentName: string): Promise<Blob> {
  const formData = new URLSearchParams();
  formData.append("file_name", documentName);
  const result = await fetch(`${API_BASE_URL}compile`, { method: "POST", body: formData });
  if (result.status !== 200) {
    throw new Error(`API Error ${result.status}: ${result.statusText}\n${await result.text()}`);
  }
  return await result.blob();
}

export async function resetAllFiles(): Promise<void> {
  await apiQuery(`${API_BASE_URL}reset`, "");
}